import { render, staticRenderFns } from "./dialog-save-personnel.vue?vue&type=template&id=059ba59c&scoped=true&"
import script from "./dialog-save-personnel.vue?vue&type=script&lang=js&"
export * from "./dialog-save-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ba59c",
  null
  
)

export default component.exports